"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeUnitTable = void 0;
exports.resolveTimeUnit = resolveTimeUnit;
exports.convertTimeUnit = convertTimeUnit;
/**
 * Defines each unit available to the time unit functions.
 */
exports.timeUnitTable = {
    ms: 1,
    millisecond: 1,
    milliseconds: 1,
    s: 1000,
    sec: 1000,
    second: 1000,
    seconds: 1000,
    min: 60 * 1000,
    minute: 60 * 1000,
    minutes: 60 * 1000,
    hr: 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    hours: 60 * 60 * 1000,
    d: 24 * 60 * 60 * 1000,
    day: 24 * 60 * 60 * 1000,
    days: 24 * 60 * 60 * 1000,
    wk: 7 * 24 * 60 * 60 * 1000,
    week: 7 * 24 * 60 * 60 * 1000,
    weeks: 7 * 24 * 60 * 60 * 1000,
    yr: 365 * 24 * 60 * 60 * 1000,
    year: 365 * 24 * 60 * 60 * 1000,
    years: 365 * 24 * 60 * 60 * 1000, // ~1 / 250_000 of max safe int
};
/**
 * Return the number of milliseconds that a number + time unit corresponds to.
 * Example: resolveTimeUnit(2, "minutes") === 2 * 60 * 1000.
 *
 * @param {number} amt
 * @param {string} unit
 * @returns {number}
 */
function resolveTimeUnit(amt, unit) {
    const unitAmt = exports.timeUnitTable[unit];
    if (!unitAmt) {
        throw new Error("Unrecognized time unit " + unit);
    }
    return amt * unitAmt;
}
/**
 * Convert the passed quantity from one time unit system to another.
 * Example: convertTimeUnit(2, "minutes", "seconds") === 2 * 60
 *
 * @param {number} amt
 * @param {string} from
 * @param {string} to
 * @returns {number}
 */
function convertTimeUnit(amt, from, to) {
    const amtInMs = resolveTimeUnit(amt, from);
    const oneToUnit = resolveTimeUnit(1, to);
    return amtInMs / oneToUnit;
}
//# sourceMappingURL=TimeUnit.js.map